/*
 * 文件说明: 展示链上数据表格，查询失败或无结果时保留页面并显示无数据状态。
 */
import React, { useState, useEffect, useMemo } from 'react'
import {query} from '../LiquityData'
import Table from "./ReactTable"
import {formatDate} from '../../utils/Timestamps'
import {ellipsesStr, toLink} from '../../utils/ChartUtils'

function Liquidations() {
    const [data, setData] = useState([])

    useEffect(() => {
        (async () => {
          const result = await getRecentLiquidations()
          setData(result);
        })().catch(error => {
          console.error(error)
          setData(null)
        })
    }, [])

    const columns = useMemo(
        () => [
            {
                Header: "Timestamp",
                accessor: "timeString",
                width: 150
            },
            {
                Header: "Owner",
                accessor: "owner",
                width: 150,
                Cell: ({ cell: { value } }) => toLink('https://etherscan.io/address/' + value, ellipsesStr(value))
            },
            {
                Header: "Collateral (ETH)",
                accessor: "collateralInETH",
                width: 150
            },
            {
                Header: "Debt (LUSD)",
                accessor: "debtInUSD",
                width: 150
            },
            {
                Header: "ETH Price (USD)",
                accessor: "ethPrice",
                width: 150
            },
            {
                Header: "Collateral Ratio",
                accessor: "collateralRatio",
                width: 150
            },
            {
                Header: "Transaction",
                accessor: "transaction",
                width: 150,
                Cell: ({ cell: { value } }) => toLink('https://etherscan.io/tx/' + value, ellipsesStr(value))
            }
        ],
        []
    )

    if (!data || data.length === 0) return 'No data'
    return (
        <div className="liquidations">
          <Table columns={columns} data={data} />
        </div>
    )
}

async function getRecentLiquidations() {
    const gql = `
    {
        liquidations(first:100, orderBy:sequenceNumber, orderDirection: desc)
      {
        transaction
        {
          id
          timestamp
        }
        liquidator
        {
          id
        }
        liquidatedDebt
        liquidatedCollateral
        troveChanges
        {
          collateralRatioBefore
          systemStateBefore
          {
               price
          }
        }
      }
    }
    `
    let data = await query(gql)
    let liquiations = data.liquidations.slice()
    //Sort by timestamp descending order
    liquiations.sort((a, b) => a.transaction.timestamp > b.transaction.timestamp ? -1 : 1)
    //Format data
    let result = liquiations.map((item) => {
        return {
            timeString: formatDate(item.transaction.timestamp, 'YYYY-MM-DD HH:mm'),
            owner: item.liquidator.id,
            collateralInETH: parseFloat(item.liquidatedCollateral).toFixed(4),
            debtInUSD: parseFloat(item.liquidatedDebt).toFixed(2),
            ethPrice: parseFloat(item.troveChanges[0].systemStateBefore.price).toFixed(2),
            collateralRatio: parseFloat(item.troveChanges[0].collateralRatioBefore * 100).toFixed(2)+"%",
            transaction: item.transaction.id
        }
    })
    return result
}

export default Liquidations
